import api from 'src/Utils/api';
export var deleteCommonExpensesReceipt = function (_a) {
    var id = _a.id;
    return api.delete("/common_expenses_receipts/" + id);
};
